const transliterate = text => {
  const cyrillicToLatinMap = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'e',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'kh',
    ц: 'c',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ъ: '',
    ы: 'y',
    ь: '',
    э: 'e',
    ю: 'yu',
    я: 'ya',
  }

  return text
    .split('')
    .map(
      char =>
        cyrillicToLatinMap[char.toLowerCase()] ||
        (/[a-z0-9]/i.test(char) ? char.toLowerCase() : '-')
    )
    .join('')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') // Убираем лишние тире в начале и конце
}

export const FormatToAnchor = title => {
  return transliterate(title)
    .replace(/[^a-z0-9-]/gi, '') // Удаляем все символы, кроме латинских букв, цифр и тире
    .replace(/\s+/g, '-') // Заменяем пробелы на тире
    .toLowerCase()
}
